import {Model as BaseModel} from 'vue-api-query'

export default class Model extends BaseModel {
    /**
     * New instance
     *
     * @returns {Model}
     */
    static instance() {
        return new this
    }

    /**
     * Delete model
     *
     * @param id
     * @param params
     * @returns {*}
     */
    static delete(id, params = null) {
        return axios.delete(`/${this.instance().resource()}/${id}`, {
            data: params
        })
    }

    /**
     * Delete model
     *
     * @param id
     * @returns {Promise<unknown>}
     */
    static restore(id) {
        return axios.post(`/${this.instance().resource()}/${id}/restore`)
    }

    /**
     * Define a base url for a REST API
     * @returns {String}
     */
    baseURL() {
        return window.App.state.config.app.url;
    }

    /**
     * @return {string}
     */
    computedResource() {
        return this._customResource ? this._customResource : this.resource()
    }

    /**
     * Implement a default request method
     *
     * @param config
     * @returns {*|Promise<AxiosResponse<T>>|ClientRequest|ClientHttp2Stream}
     */
    request(config) {
        return this.$http.request(config)
    }

    /**
     * Save current model
     *
     * @param {String|null} params
     * @returns {Promise<unknown>}
     */
    save(params = null) {
        return App.post(`${this.baseURL()}/${this.computedResource()}?${params ? params : ''}`, this)
    }

    /**
     * Save current model using FormData.
     *
     * @param {String|null} params
     * @returns {Promise<unknown>}
     */
    saveData(params = null) {
        return App.postData(`${this.baseURL()}/${this.computedResource()}?${params ? params : ''}`, this)
    }

    /**
     * Update current model
     *
     * @param {String|null} params
     * @returns {Promise<unknown>}
     */
    update(params = null) {
        if (!this.getPrimaryKey()) {
            throw new Error('You must specify an id.')
        }
        return App.put(`${this.baseURL()}/${this.computedResource()}/${this.getPrimaryKey()}?${params ? params : ''}`, this)
    }

    /**
     * Update current model using FormData.
     *
     * @param {String|null} params
     * @returns {Promise<unknown>}
     */
    updateData(params = null) {
        if (!this.getPrimaryKey()) {
            throw new Error('You must specify an id.')
        }
        return App.putData(`${this.baseURL()}/${this.computedResource()}/${this.getPrimaryKey()}?${params ? params : ''}`, this)
    }
}
